export default "__VITE_ASSET__DvI_skMt__"